module.exports = __webpack_public_path__ + "static/2-5204f2bc6956cb1c1d5cc7aeadf91c0c.jpg";